import { useState } from 'react'
import { ls, LocalStorageKey, LocalStorageValueType } from '@clofo/data/local-storage'

export function useLocalStorageState<K extends LocalStorageKey>(
  key: K,
  defaultValue: LocalStorageValueType<K>,
): [LocalStorageValueType<K>, (value: LocalStorageValueType<K>) => void]

export function useLocalStorageState<K extends LocalStorageKey>(
  key: K,
  defaultValue?: LocalStorageValueType<K>,
): [LocalStorageValueType<K> | undefined, (value: LocalStorageValueType<K>) => void] {
  const [value, setValue] = useState<LocalStorageValueType<K> | undefined>(
    () => ls.getItem(key) ?? defaultValue,
  )

  const onChange = (value: LocalStorageValueType<K>) => {
    setValue(value)
    ls.setItem(key, value)
  }

  return [value, onChange]
}
